// store/cartStore.js
import { defineStore } from "pinia";
import { ref } from "vue";

export const useCartStore = defineStore("cart", () => {
  const isCartActive = ref(false);
  const selectedOptions = ref({});
  const hideCategoriesBlock = ref(false);

  const toggleCart = (options = null) => {
    if (options) {
      selectedOptions.value = { ...options };
    }
    isCartActive.value = !isCartActive.value;
    document.body.classList.toggle("no-scroll");
  };

  const closeCart = () => {
    isCartActive.value = false;
    hideCategoriesBlock.value = false; // 🟢 сбрасываем обратно при закрытии
    document.body.classList.remove("no-scroll");
  };

  const setHideCategoriesBlock = (value) => {
    hideCategoriesBlock.value = value;
  };

  return {
    isCartActive,
    selectedOptions,
    hideCategoriesBlock,
    toggleCart,
    closeCart,
    setHideCategoriesBlock,
  };
});
